const schema = localStorage.getItem("schema");
const userDetails = JSON.parse(localStorage.getItem("authUser"));
export const sparePartRequestFormData = () => ({
  inputData: {
    // id: null,
    intake_id: null,
    job_card_id: null,
    scrap_reason_id: null,
    approved_by: userDetails?.id,
    approved_at: new Date().toISOString().replace("T", " ").slice(0, 19),
    remark: null,
    status: "Approved",
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "scraps",
    schema: "public",

    include: [
      {
        model: "material_intakes",
        as: "intake",
      },
      {
        model: "scrap_reason_masters",
        as: "reason",
      },
      {
        model: "user_masters",
        as: "approved_by_user",
      },
    ],
  };

  const navigatePage = { back: "/scrap-list" };

  const headerName = "Scrap";

  const validationType = "ScrapCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata  ";

  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};
